const server = process.env.REACT_APP_SERVER;

export async function generateResponseFromGPT(prompt) {
    try {
        const jsonBody = JSON.stringify({prompt: prompt});
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json'},
            body: jsonBody
        };
        const response = await fetch(`${server}/gencontent`, requestOptions);
        return response;
    }
    catch (e) {
        console.error(e, 'generateResponseFromGPT');
    }
}